// extracted by mini-css-extract-plugin
export default {"repoList":"RepoList_repoList__KUmaE","intro":"RepoList_intro__K+kj2","pagination":"RepoList_pagination__8dZod","linksContainer":"RepoList_linksContainer__Wpc5z"};